export const BORROWER_DETAILS_SIDEBAR_TAB_NAMES = {
  DETAILS: "Details",
  LOANS: "Loans",
  // DOCUMENTS: "Documents",
  DOCUMENTS: "Documents",
  DOCUMENTS_PARSED: "Parsed Docs",
  ENTITIES: "Entities",
  BANK_INFO: "Bank Info",
  EXPERIENCE: "Experience",
  RAW_JSON: "JSON",
};
